import React, { Component } from 'react';

class ModalConfirmarSalir extends Component {

    constructor(props) {
        super(props);
        this.cerrarModalYSalir = this.cerrarModalYSalir.bind(this)
    }
    cerrarModalYSalir(){
        this.props.mostrarModal(4,false);
        this.props.getErroresProceso(false);
    }
    render() {
        const {data} = this.props;
        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS'>
                    <div className='text-right'>
                        <label onClick={()=>this.props.mostrarModal(4,false)} className='ti-close clickable modalProcesosClose closeProcesosDemanda'></label>        
                    </div>
                    <div className='modalConfirmarSalirTexto'>
                        ¿Está seguro de que desea abandonar la pantalla actual?
                    </div>
                    <div className='modalProcesosFooterShort'>
                        <button onClick={()=>this.props.mostrarModal(4,false)} className="btn btn-secondary">Cancelar</button>
                        <button className="btn btn-cta" onClick={()=>this.cerrarModalYSalir()}>Aceptar</button>                        
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalConfirmarSalir;   